module.exports = __webpack_public_path__ + "static/img/002.901f5083.png";